import dynamic from 'next/dynamic'

/**
 * Adaptor for ReactPlayer component from NPM
 *
 * Load ReactPlayer dynamically so that we don't render differently on the
 * server and on the client, leading to hydration errors.
 */
export const ReactPlayer = dynamic(() => import('react-player/lazy'), { ssr: false })
